import UtilsService from '../utils/utils.service';

const CustomerService = {
  init: async () => {
    UtilsService.debugLog('Customer Service Init');
  },
};

export default CustomerService;
